import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { UserRolesIds } from '@models';
import { Store } from '@ngrx/store';
import { AuthSelectors } from '@ngrx-store';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[avsRestrictedEl]',
})
export class RestrictedElementDirective implements OnDestroy, OnInit {
  subs!: Subscription;
  @Input() showForClientAdmin = false;

  constructor(private store: Store, private elementRef: ElementRef) { }

  ngOnInit(): void {
    this.subs = this.store.select(AuthSelectors.userRole).subscribe((role: UserRolesIds) => {
      if (role !== UserRolesIds.SuperAdmin) {
        if (role === UserRolesIds.ClientAdmin && this.showForClientAdmin) return;
        this.elementRef.nativeElement.style.setProperty('display', 'none', 'important');
      }
    });
  }

  ngOnDestroy(): void {
    this.subs?.unsubscribe();
  }
}
